import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "ModuleNewsletterModelProducts" })
export default class ModuleNewsletterModelProducts extends Vue {
    private isLoading: boolean = false;
    private formData: any = {};
    private validationErrors: any[] = [];

    get navigationContext(): any {
        return this.$store.getters["navigationStore/navigationContext"];
    }

    get itemIdMaster() {
        return this.$store.getters["itemStore/itemIdMaster"];
    }

    private async setHtmlTemplate() {
        this.isLoading = true;
        this.validationErrors = [];

        try {
            const response = (await Axios.post("/dataweb/api/module/modulenewslettermodelproducts/sethtmltemplate?nav=" + this.navigationContext.nav, this.formData)).data;

            this.$store.dispatch("toastStore/onAddToast", { message: "Template generato con successo", type: "Success" });
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
        this.isLoading = false;
    }

    public getModuleData() {
        let moduleData = { isCompleted: true };
        return moduleData;
    }

    private isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};